export default "__VITE_ASSET__BSlaJvGr__"